import React from 'react';
import { DateTime } from 'luxon';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Button,
  Box,
} from '@mui/material';
import palette from '../../../../theme/palette';
import makeStyles from '@mui/styles/makeStyles';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import { MoneyFormattedUtils } from '../../../../utils';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

const useStyles = makeStyles(() => ({
  buttonCheckout: {
    backgroundColor: palette.utriper.darkgreen,
    color: '#fff',
    '&:hover': {
      backgroundColor: palette.utriper.green,
    },
  },
}));

type info = {
  id: number;
  startUTC: string;
  timezone: string;
  currency: string;
  priceTotal: number;
};

type experience = {
  name: string;
  expDetailId: number;
};

interface ExperienceDetailsProps {
  info: info;
  quantity: number;
  experience: experience;
}

const ExperienceDetails: React.FC<ExperienceDetailsProps> = ({
  info,
  quantity,
  experience,
}) => {
  const { currency, priceTotal } = info || {};
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const handleCheckout = () => {
    history.push({
      pathname: '/checkout',
      state: {
        id: info.id,
        experienceDetailId: experience.expDetailId,
        groupSize: quantity,
        price: priceTotal,
      },
    });
  };

  return (
    <Box>
      <CardContent>
        <Typography variant="h5" component="h2">
          {experience.name} Details
        </Typography>
        <List>
          <ListItem>
            <EventIcon />
            <ListItemText
              primary={`Date: ${DateTime.fromISO(info.startUTC)
                .setZone(info.timezone)
                .toFormat('EEE dd MMMMM yyyy')}`}
              secondary=""
            />
          </ListItem>
          <ListItem>
            <PeopleIcon />
            <ListItemText
              primary={`Start: ${DateTime.fromISO(info.startUTC)
                .setZone(info.timezone)
                .toFormat('HH:mm')}`}
              secondary=""
            />
          </ListItem>
          <ListItem>
            <AttachMoneyIcon />
            <ListItemText
              primary={`Total: ${
                priceTotal
                  ? `${currency} ${MoneyFormattedUtils(priceTotal)}`
                  : 'FREE'
              }`}
              secondary={``}
            />
          </ListItem>
        </List>
        <Divider />
        <Button
          className={classes.buttonCheckout}
          variant="contained"
          fullWidth
          onClick={handleCheckout}>
          {translate('coreUi.utils.goToCheckout')}
        </Button>
      </CardContent>
    </Box>
  );
};

export default ExperienceDetails;
